<template>
  <header class="header">
    <div class="header__content">

      <router-link
        :to="{ name: 'dashboard' }"
        class="header__logo-link"
      >
        <img
          alt="Claussen-Simon-Stiftung Logo"
          class="header__logo header__logo--large"
          height="65"
          src="@/assets/logo.svg"
          width="350"
        >
        <img
          alt="Claussen-Simon-Stiftung Logo"
          class="header__logo header__logo--icon"
          height="35"
          src="@/assets/icon.svg"
          width="35"
        >
      </router-link>

      <div class="header__nav">

        <c-button-router-link
          v-if="$store.state.user.isLoggedIn && $store.state.user.data.completed_registration"
          :to="{ name: 'dashboard' }"
        >
          Dashboard
        </c-button-router-link>

        <button
          v-if="$store.state.user.isLoggedIn"
          class="header__link"
          @click="logout"
        >
          Abmelden
        </button>

        <a
          class="header__link"
          href="https://www.claussen-simon-stiftung.de/de/legal/kontakt/"
          rel="noopener"
          target="_blank"
        >
          Kontakt
        </a>

      </div>

    </div>
  </header>
</template>

<script>
import CButtonRouterLink from '@/components/CButtonRouterLink'

import reset from '@/functions/reset'
import sessionToken from '@/functions/sessionToken'

export default {
  name: 'SHeader',

  components: {
    CButtonRouterLink
  },

  methods: {
    logout () {
      sessionToken.remove()
      reset.store()
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
.header {
  position: relative;
  padding: calc(var(--grid-spacing) / 2) 0;
  z-index: var(--z-index-header);

  /* Hide notifications under header */
  background-color: #fff;
}

@media (min-width: 720px) {
  .header {
    padding: var(--grid-spacing) 0;
  }
}

.header__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: var(--container-width);
  max-width: 100%;
  margin: 0 auto;
  padding: 0 var(--container-padding);
}

@media (min-width: 720px) {
  .header__content {
    align-items: flex-end;
  }
}

.header__logo-link {
  flex-shrink: 0;
}

.header__logo {
  vertical-align: middle;
}

.header__logo--large {
  display: none;
  width: 11.5em;
}

@media (min-width: 720px) {
  .header__logo--large {
    display: inline;
  }

  .header__logo--icon {
    display: none;
  }
}

.header__nav {
  margin-left: var(--grid-spacing);

  text-align: right;
  line-height: 1.6;
}

.header__link {
  display: inline-block;
  padding: 0;
  margin-left: 15px;

  text-decoration: none;
  line-height: inherit;
  color: var(--color-text);

  background: none;
  border: 0;
}

.header__link:hover {
  text-decoration: underline;
}

</style>
